module.exports = __webpack_public_path__ + "img/pirate.e5a0e02b.png";